<template>
  <simple-page class="h-100 bg-primary">
    <div class="col-md-8 col-lg-6">
      <!--
      ==========================================================================
      Page header
      ==========================================================================
      -->
      <h2 class="text-white text-center">
        <i class="fa fa-fw fa-lock"></i>
        {{ $env.app.name }}
      </h2>
      <!--
      ==========================================================================
      Page body
      ==========================================================================
      -->
      <b-card-group class="rounded-lg box-shadow-dark">
        <!--
        ==========================================================================
        Image
        ==========================================================================
        -->
        <b-card class="d-none d-md-block border-0 bg-cover bg-reset-password">
        </b-card>
        <!--
        ==========================================================================
        Form
        ==========================================================================
        -->
        <b-card class="rounded-lg box-shadow-dark py-4">
          <editor @password-reset="passwordReset" />
        </b-card>
      </b-card-group>
      <!--
      ==========================================================================
      Page footer
      ==========================================================================
      -->
      <div class="text-right mt-2">
        <router-link
          class="font-decoration-none text-white font-weight-bold"
          :to="{ name: 'Login' }"
        >
          {{ $t("resetPassword.actions.goBackToLoginPage") }}
        </router-link>
      </div>
    </div>
  </simple-page>
</template>
<script>
import editor from "vue-template/public/editors/ResetPasswordEditor";

export default {
  components: {
    editor
  },

  props: {
    defaultRoute: {
      type: [String, Object],
      default: () => ({ name: 'Message' })
    }
  },

  methods: {
    passwordReset(/*result*/) {
      const obj = this.$route.query.redirect || this.defaultRoute;
      if (!obj.params) obj.params = {};
      obj.params = {
        ...obj.params,
        flashVariant: 'success',
        flash: 'La richiesta per reimpostare la tua password è stata inviata: clicca sul link che riceverai via e-mail per completare l\'operazione.', // TODO i18n
      };
      console.log('Pushing route', obj);
      this.$router.push(obj);
    }
  }
};
</script>
